// Helper to look for values in runtimeConfig first, then process.env
const getEnv = (key, defaultValue) => {
  const value = window.runtimeConfig?.[key] ?? process.env[`REACT_APP_${key}`];
  return value ?? defaultValue;
};

// Helper specifically for booleans to handle "true"/"false" strings
const getBool = (key, defaultValue = false) => {
  const value = getEnv(key, defaultValue);
  return String(value).toLowerCase() === "true";
};

const config = {
  apiUrl: getEnv("API_URL", "http://localhost:8000"),
  authUrl: getEnv("AUTH_URL"),
  clinicCentralBackendUrl: getEnv("CLINIC_CENTRAL_BACKEND_URL"),
  clinicCentralUrl: getEnv("CLINIC_CENTRAL_URL"),

  // This now correctly handles boolean logic and type conversion
  applicationsEnabled: getBool("APPLICATIONS_ENABLED", true),
};

export default config;
